// msalService.js

import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: '0811bdbe-a893-4f3e-9f1b-e7f2d8938dd9',
    authority: 'https://login.microsoftonline.com/dd431735-6d64-4f59-9f90-09a50f9cb593',
    redirectUri: 'https://campus.pickiddo.com/outh', // Adjust accordingly
  },
  cache: {
    cacheLocation: 'sessionStorage', // or 'localStorage'
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
